import React from 'react';
import { useTranslation } from 'react-i18next';
import useSeo from '../hooks/useSeo';
import { usePageContent } from './home/pageContent';
import { BoxGrid, CardStack, CheckList, FeatureIcon, PageHero, PageShell, SectionIntro, ShowcaseCard } from './home/blocks';
import CtaBanner from './home/CtaBanner';

/* Built from the Figma "Functionaliteiten" blocks. Content: Admin → Landingspagina → Hoe het werkt. */
const HoeHetWerkt = () => {
  const { t } = useTranslation();
  const { lang, cms, content } = usePageContent('how');
  const steps = content.steps.items;

  useSeo({
    path: '/hoe-het-werkt',
    lang,
    title: cms?.seo?.title || t('how_it_works.seo_title'),
    description: cms?.seo?.description || t('how_it_works.seo_description'),
    jsonLd: {
      '@context': 'https://schema.org',
      '@type': 'HowTo',
      name: t('how_it_works.title'),
      description: content.hero.subtitle,
      step: steps.map((s, i) => ({ '@type': 'HowToStep', position: i + 1, name: s.title, text: s.body })),
    },
  });

  return (
    <PageShell testId="hoe-het-werkt-page">
      <PageHero hero={content.hero} />
      <SectionIntro />
      <CardStack>
        {steps.map((step, i) => (
          <ShowcaseCard
            key={i}
            id={`stap-${i + 1}`}
            card={{ ...step, image_fit: 'cover' }}
            index={i}
            icon={<FeatureIcon number={i + 1} />}
            kicker={`${content.steps.step_label} ${i + 1}`}
          >
            <CheckList items={step.tips} />
          </ShowcaseCard>
        ))}
      </CardStack>
      <BoxGrid id="meer" kicker={content.extras.kicker} title={content.extras.title} subtitle={content.extras.subtitle} items={content.extras.items} />
      <div className="pt-[clamp(0px,5.3333vw,96px)]">
        <CtaBanner cta={content.cta} wide />
      </div>
    </PageShell>
  );
};

export default HoeHetWerkt;
